import { render, staticRenderFns } from "./volunteerActivity-add.vue?vue&type=template&id=c59d7ea4&"
import script from "./volunteerActivity-add.vue?vue&type=script&lang=js&"
export * from "./volunteerActivity-add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports